import api from '../../api/api';

export function retrieveOrderDetailsService(appendedUrl, data) {
    const url = "api/OrderDetailService/" + appendedUrl;
    return api.request(url, "post", data)
        .then(res => res);
}

export function retrieveRelocatinPlanPurposesDetails(caseID, productGroupCode, travelTypeID) {}